/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The concept of a date without a time and/or timezone, e.g. My birthday is January 1st, 1864 regardless of timezone. */
  Date: { input: any; output: any; }
  /** Returns a string in simplified extended ISO format (ISO 8601), which is always 24 or 27 characters long (YYYY-MM-DDTHH:mm:ss.sssZ or ±YYYYYY-MM-DDTHH:mm:ss.sssZ, respectively). The timezone is always zero UTC offset, as denoted by the suffix "Z". */
  ISOString: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AccordionItem = {
  __typename?: 'AccordionItem';
  content: Scalars['String']['output'];
  council?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExpanded?: Maybe<Scalars['Boolean']['output']>;
  itemOrder: Scalars['Float']['output'];
  location: AccordionLocation;
  title: Scalars['String']['output'];
};

/** Data needed to create or update AccordionItems. If an ID is passed, this is an update, otherwise it's an insert. */
export type AccordionItemCreateOrUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<AccordionLocation>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create AccordionItems. */
export type AccordionItemInsertInput = {
  content: Scalars['String']['input'];
  council?: InputMaybe<Scalars['String']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder: Scalars['Float']['input'];
  location: AccordionLocation;
  title: Scalars['String']['input'];
};

/** Data needed to update AccordionItems. An ID must be passed. */
export type AccordionItemUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<AccordionLocation>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<AccordionItemsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<AccordionItemsListFilter>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_ilike?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<Scalars['String']['input']>>;
  content_like?: InputMaybe<Scalars['String']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  content_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  content_null?: InputMaybe<Scalars['Boolean']['input']>;
  council?: InputMaybe<Scalars['String']['input']>;
  council_gt?: InputMaybe<Scalars['String']['input']>;
  council_gte?: InputMaybe<Scalars['String']['input']>;
  council_ilike?: InputMaybe<Scalars['String']['input']>;
  council_in?: InputMaybe<Array<Scalars['String']['input']>>;
  council_like?: InputMaybe<Scalars['String']['input']>;
  council_lt?: InputMaybe<Scalars['String']['input']>;
  council_lte?: InputMaybe<Scalars['String']['input']>;
  council_ne?: InputMaybe<Scalars['String']['input']>;
  council_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  council_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  council_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isExpanded_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isExpanded_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_null?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  itemOrder_ne?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  itemOrder_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder_null?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AccordionLocation>;
  location_in?: InputMaybe<Array<AccordionLocation>>;
  location_nin?: InputMaybe<Array<AccordionLocation>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionItemsOrderByInput = {
  content?: InputMaybe<Sort>;
  council?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isExpanded?: InputMaybe<Sort>;
  itemOrder?: InputMaybe<Sort>;
  location?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

/** Pagination options for AccordionItems. */
export type AccordionItemsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccordionItemsOrderByInput>;
};

export enum AccordionLocation {
  AboutSubscriptions = 'ABOUT_SUBSCRIPTIONS',
  AppUpdates = 'APP_UPDATES',
  BagScanned = 'BAG_SCANNED',
  HelpAccount = 'HELP_ACCOUNT',
  HelpCurbyRewards = 'HELP_CURBY_REWARDS',
  HelpMaterialsWeRecycle = 'HELP_MATERIALS_WE_RECYCLE',
  HelpMission = 'HELP_MISSION',
  HelpOtherMaterials = 'HELP_OTHER_MATERIALS',
  HelpProgram = 'HELP_PROGRAM',
  HelpProgramMaterial = 'HELP_PROGRAM_MATERIAL',
  InformExisting = 'INFORM_EXISTING',
  RewardsHowItWorks = 'REWARDS_HOW_IT_WORKS',
  RewardsTsAndCs = 'REWARDS_TS_AND_CS',
  SubscriptionDetails = 'SUBSCRIPTION_DETAILS'
}

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update Accounts. If an ID is passed, this is an update, otherwise it's an insert. */
export type AccountCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Accounts. */
export type AccountInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Accounts. An ID must be passed. */
export type AccountUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AccountsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<AccountsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<AccountsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for Accounts. */
export type AccountsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountsOrderByInput>;
};

export type AdminUiEntityAttributeMetadata = {
  __typename?: 'AdminUiEntityAttributeMetadata';
  clientGeneratedPrimaryKeys?: Maybe<Scalars['Boolean']['output']>;
  exportPageSize?: Maybe<Scalars['Float']['output']>;
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUiEntityMetadata = {
  __typename?: 'AdminUiEntityMetadata';
  attributes: AdminUiEntityAttributeMetadata;
  backendDisplayName?: Maybe<Scalars['String']['output']>;
  backendId?: Maybe<Scalars['String']['output']>;
  defaultFilter?: Maybe<Scalars['JSON']['output']>;
  defaultSort?: Maybe<Scalars['JSON']['output']>;
  excludeFromTracing: Scalars['Boolean']['output'];
  fieldForDetailPanelNavigationId: Scalars['String']['output'];
  fields: Array<AdminUiFieldMetadata>;
  hideInSideBar: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  primaryKeyField: Scalars['String']['output'];
  summaryField?: Maybe<Scalars['String']['output']>;
  supportedAggregationTypes: Array<AggregationType>;
  supportsPseudoCursorPagination: Scalars['Boolean']['output'];
};

export type AdminUiEnumMetadata = {
  __typename?: 'AdminUiEnumMetadata';
  name: Scalars['String']['output'];
  values: Array<AdminUiEnumValueMetadata>;
};

export type AdminUiEnumValueMetadata = {
  __typename?: 'AdminUiEnumValueMetadata';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminUiFieldAttributeMetadata = {
  __typename?: 'AdminUiFieldAttributeMetadata';
  isReadOnly: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
};

export type AdminUiFieldExtensionsMetadata = {
  __typename?: 'AdminUiFieldExtensionsMetadata';
  key?: Maybe<Scalars['String']['output']>;
};

export type AdminUiFieldMetadata = {
  __typename?: 'AdminUiFieldMetadata';
  attributes?: Maybe<AdminUiFieldAttributeMetadata>;
  extensions?: Maybe<AdminUiFieldExtensionsMetadata>;
  filter?: Maybe<AdminUiFilterMetadata>;
  hideInDetailForm?: Maybe<Scalars['Boolean']['output']>;
  hideInFilterBar?: Maybe<Scalars['Boolean']['output']>;
  hideInTable?: Maybe<Scalars['Boolean']['output']>;
  isArray?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  relatedEntity?: Maybe<Scalars['String']['output']>;
  relationshipType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminUiFilterMetadata = {
  __typename?: 'AdminUiFilterMetadata';
  type: AdminUiFilterType;
};

export enum AdminUiFilterType {
  Boolean = 'BOOLEAN',
  DateRange = 'DATE_RANGE',
  DropDownText = 'DROP_DOWN_TEXT',
  Enum = 'ENUM',
  Numeric = 'NUMERIC',
  Relationship = 'RELATIONSHIP',
  Text = 'TEXT'
}

export type AdminUiMetadata = {
  __typename?: 'AdminUiMetadata';
  entities: Array<AdminUiEntityMetadata>;
  enums: Array<AdminUiEnumMetadata>;
};

export type AggregationResult = {
  __typename?: 'AggregationResult';
  count: Scalars['Int']['output'];
};

export enum AggregationType {
  Count = 'COUNT'
}

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  revoked?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type ApiKeyInsertInput = {
  key: Scalars['String']['input'];
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  secret: Scalars['String']['input'];
};

export type ApiKeyUpdateInput = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeysListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ApiKeysListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<ApiKeysListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_gt?: InputMaybe<Scalars['String']['input']>;
  key_gte?: InputMaybe<Scalars['String']['input']>;
  key_ilike?: InputMaybe<Scalars['String']['input']>;
  key_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_like?: InputMaybe<Scalars['String']['input']>;
  key_lt?: InputMaybe<Scalars['String']['input']>;
  key_lte?: InputMaybe<Scalars['String']['input']>;
  key_ne?: InputMaybe<Scalars['String']['input']>;
  key_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  key_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  key_null?: InputMaybe<Scalars['Boolean']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  revoked_ne?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  revoked_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetType {
  Bag = 'BAG',
  PayloadTag = 'PAYLOAD_TAG',
  Tag = 'TAG'
}

export type BatchCode = {
  __typename?: 'BatchCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISOString']['output'];
  createdByUser: User;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  trackableAssets: Array<TrackableAsset>;
  trackableAssets_aggregate?: Maybe<AggregationResult>;
};


export type BatchCodeCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type BatchCodeCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type BatchCodeTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type BatchCodeTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update BatchCodes. If an ID is passed, this is an update, otherwise it's an insert. */
export type BatchCodeCreateOrUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to create BatchCodes. */
export type BatchCodeInsertInput = {
  code: Scalars['String']['input'];
  createdAt: Scalars['ISOString']['input'];
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to update BatchCodes. An ID must be passed. */
export type BatchCodeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

export type BatchCodesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<BatchCodesListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<BatchCodesListFilter>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_gt?: InputMaybe<Scalars['String']['input']>;
  code_gte?: InputMaybe<Scalars['String']['input']>;
  code_ilike?: InputMaybe<Scalars['String']['input']>;
  code_in?: InputMaybe<Array<Scalars['String']['input']>>;
  code_like?: InputMaybe<Scalars['String']['input']>;
  code_lt?: InputMaybe<Scalars['String']['input']>;
  code_lte?: InputMaybe<Scalars['String']['input']>;
  code_ne?: InputMaybe<Scalars['String']['input']>;
  code_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  code_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  code_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssets?: InputMaybe<TrackableAssetsListFilter>;
};

export type BatchCodesOrderByInput = {
  code?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for BatchCodes. */
export type BatchCodesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BatchCodesOrderByInput>;
};

export type Blacklist = {
  __typename?: 'Blacklist';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Data needed to create or update Blacklists. If an ID is passed, this is an update, otherwise it's an insert. */
export type BlacklistCreateOrUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Data needed to create Blacklists. */
export type BlacklistInsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Blacklists. An ID must be passed. */
export type BlacklistUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type BlacklistsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<BlacklistsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<BlacklistsListFilter>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlacklistsOrderByInput = {
  email?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for Blacklists. */
export type BlacklistsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BlacklistsOrderByInput>;
};

export type Case = {
  __typename?: 'Case';
  account?: Maybe<Account>;
  account_aggregate?: Maybe<AggregationResult>;
  caseNumber?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contact_aggregate?: Maybe<AggregationResult>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};


export type CaseAccountArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type CaseAccount_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type CaseContactArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type CaseContact_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};

/** Data needed to create or update Cases. If an ID is passed, this is an update, otherwise it's an insert. */
export type CaseCreateOrUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Cases. */
export type CaseInsertInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Cases. An ID must be passed. */
export type CaseUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CasesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<CasesListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<CasesListFilter>>>;
  account?: InputMaybe<AccountsListFilter>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  caseNumber_gt?: InputMaybe<Scalars['String']['input']>;
  caseNumber_gte?: InputMaybe<Scalars['String']['input']>;
  caseNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  caseNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  caseNumber_like?: InputMaybe<Scalars['String']['input']>;
  caseNumber_lt?: InputMaybe<Scalars['String']['input']>;
  caseNumber_lte?: InputMaybe<Scalars['String']['input']>;
  caseNumber_ne?: InputMaybe<Scalars['String']['input']>;
  caseNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  caseNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  caseNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<ContactsListFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  priority_gt?: InputMaybe<Scalars['String']['input']>;
  priority_gte?: InputMaybe<Scalars['String']['input']>;
  priority_ilike?: InputMaybe<Scalars['String']['input']>;
  priority_in?: InputMaybe<Array<Scalars['String']['input']>>;
  priority_like?: InputMaybe<Scalars['String']['input']>;
  priority_lt?: InputMaybe<Scalars['String']['input']>;
  priority_lte?: InputMaybe<Scalars['String']['input']>;
  priority_ne?: InputMaybe<Scalars['String']['input']>;
  priority_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  priority_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  priority_null?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_gt?: InputMaybe<Scalars['String']['input']>;
  reason_gte?: InputMaybe<Scalars['String']['input']>;
  reason_ilike?: InputMaybe<Scalars['String']['input']>;
  reason_in?: InputMaybe<Array<Scalars['String']['input']>>;
  reason_like?: InputMaybe<Scalars['String']['input']>;
  reason_lt?: InputMaybe<Scalars['String']['input']>;
  reason_lte?: InputMaybe<Scalars['String']['input']>;
  reason_ne?: InputMaybe<Scalars['String']['input']>;
  reason_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  reason_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  reason_null?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_ilike?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<Scalars['String']['input']>>;
  status_like?: InputMaybe<Scalars['String']['input']>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_ne?: InputMaybe<Scalars['String']['input']>;
  status_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  status_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  status_null?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_gt?: InputMaybe<Scalars['String']['input']>;
  subject_gte?: InputMaybe<Scalars['String']['input']>;
  subject_ilike?: InputMaybe<Scalars['String']['input']>;
  subject_in?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_like?: InputMaybe<Scalars['String']['input']>;
  subject_lt?: InputMaybe<Scalars['String']['input']>;
  subject_lte?: InputMaybe<Scalars['String']['input']>;
  subject_ne?: InputMaybe<Scalars['String']['input']>;
  subject_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  subject_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CasesOrderByInput = {
  caseNumber?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  priority?: InputMaybe<Sort>;
  reason?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  subject?: InputMaybe<Sort>;
};

/** Pagination options for Cases. */
export type CasesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CasesOrderByInput>;
};

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Account>;
  account_aggregate?: Maybe<AggregationResult>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};


export type ContactAccountArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type ContactAccount_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};

/** Data needed to create or update Contacts. If an ID is passed, this is an update, otherwise it's an insert. */
export type ContactCreateOrUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Contacts. */
export type ContactInsertInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Contacts. An ID must be passed. */
export type ContactUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ContactsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ContactsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactsListFilter>>>;
  account?: InputMaybe<AccountsListFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_gt?: InputMaybe<Scalars['String']['input']>;
  firstName_gte?: InputMaybe<Scalars['String']['input']>;
  firstName_ilike?: InputMaybe<Scalars['String']['input']>;
  firstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_like?: InputMaybe<Scalars['String']['input']>;
  firstName_lt?: InputMaybe<Scalars['String']['input']>;
  firstName_lte?: InputMaybe<Scalars['String']['input']>;
  firstName_ne?: InputMaybe<Scalars['String']['input']>;
  firstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_gt?: InputMaybe<Scalars['String']['input']>;
  lastName_gte?: InputMaybe<Scalars['String']['input']>;
  lastName_ilike?: InputMaybe<Scalars['String']['input']>;
  lastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_like?: InputMaybe<Scalars['String']['input']>;
  lastName_lt?: InputMaybe<Scalars['String']['input']>;
  lastName_lte?: InputMaybe<Scalars['String']['input']>;
  lastName_ne?: InputMaybe<Scalars['String']['input']>;
  lastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactsOrderByInput = {
  email?: InputMaybe<Sort>;
  firstName?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lastName?: InputMaybe<Sort>;
};

/** Pagination options for Contacts. */
export type ContactsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactsOrderByInput>;
};

export type CreateSalesforceCaseInput = {
  description: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type Credential = {
  __typename?: 'Credential';
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type CredentialInsertInput = {
  confirm: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CredentialUpdateInput = {
  confirm?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<CredentialsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<CredentialsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_gt?: InputMaybe<Scalars['String']['input']>;
  username_gte?: InputMaybe<Scalars['String']['input']>;
  username_ilike?: InputMaybe<Scalars['String']['input']>;
  username_in?: InputMaybe<Array<Scalars['String']['input']>>;
  username_like?: InputMaybe<Scalars['String']['input']>;
  username_lt?: InputMaybe<Scalars['String']['input']>;
  username_lte?: InputMaybe<Scalars['String']['input']>;
  username_ne?: InputMaybe<Scalars['String']['input']>;
  username_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  username_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  username_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialsOrderByInput = {
  id?: InputMaybe<Sort>;
  username?: InputMaybe<Sort>;
};

/** Pagination options for Credentials. */
export type CredentialsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CredentialsOrderByInput>;
};

export type CustomCreateUserInput = {
  confirm: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type DeleteCurrentUserInput = {
  comments: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type DeleteOneFilterInput = {
  id: Scalars['ID']['input'];
};

export type DropOffLocation = {
  __typename?: 'DropOffLocation';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  retailer?: Maybe<Scalars['String']['output']>;
  suburb: Scalars['String']['output'];
};

/** Data needed to create or update DropOffLocations. If an ID is passed, this is an update, otherwise it's an insert. */
export type DropOffLocationCreateOrUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create DropOffLocations. */
export type DropOffLocationInsertInput = {
  address: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
};

/** Data needed to update DropOffLocations. An ID must be passed. */
export type DropOffLocationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type DropOffLocationsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<DropOffLocationsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<DropOffLocationsListFilter>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_ilike?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_like?: InputMaybe<Scalars['String']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_ne?: InputMaybe<Scalars['String']['input']>;
  address_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  address_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  address_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lat_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_ne?: InputMaybe<Scalars['Float']['input']>;
  lat_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lat_null?: InputMaybe<Scalars['Boolean']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lng_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_ne?: InputMaybe<Scalars['Float']['input']>;
  lng_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lng_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  retailer_gt?: InputMaybe<Scalars['String']['input']>;
  retailer_gte?: InputMaybe<Scalars['String']['input']>;
  retailer_ilike?: InputMaybe<Scalars['String']['input']>;
  retailer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  retailer_like?: InputMaybe<Scalars['String']['input']>;
  retailer_lt?: InputMaybe<Scalars['String']['input']>;
  retailer_lte?: InputMaybe<Scalars['String']['input']>;
  retailer_ne?: InputMaybe<Scalars['String']['input']>;
  retailer_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  retailer_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  retailer_null?: InputMaybe<Scalars['Boolean']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  suburb_gt?: InputMaybe<Scalars['String']['input']>;
  suburb_gte?: InputMaybe<Scalars['String']['input']>;
  suburb_ilike?: InputMaybe<Scalars['String']['input']>;
  suburb_in?: InputMaybe<Array<Scalars['String']['input']>>;
  suburb_like?: InputMaybe<Scalars['String']['input']>;
  suburb_lt?: InputMaybe<Scalars['String']['input']>;
  suburb_lte?: InputMaybe<Scalars['String']['input']>;
  suburb_ne?: InputMaybe<Scalars['String']['input']>;
  suburb_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  suburb_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  suburb_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DropOffLocationsOrderByInput = {
  address?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lng?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  retailer?: InputMaybe<Sort>;
  suburb?: InputMaybe<Sort>;
};

/** Pagination options for DropOffLocations. */
export type DropOffLocationsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DropOffLocationsOrderByInput>;
};

/** Certain councils offer free tags to their residents. This entity lists those councils. */
export type FreeTagCouncil = {
  __typename?: 'FreeTagCouncil';
  council: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Data needed to create or update FreeTagCouncils. If an ID is passed, this is an update, otherwise it's an insert. */
export type FreeTagCouncilCreateOrUpdateInput = {
  council?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Data needed to create FreeTagCouncils. */
export type FreeTagCouncilInsertInput = {
  council: Scalars['String']['input'];
};

/** Data needed to update FreeTagCouncils. An ID must be passed. */
export type FreeTagCouncilUpdateInput = {
  council?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Certain councils offer free tags to their residents. This entity lists those councils. */
export type FreeTagCouncilsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<FreeTagCouncilsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<FreeTagCouncilsListFilter>>>;
  council?: InputMaybe<Scalars['String']['input']>;
  council_gt?: InputMaybe<Scalars['String']['input']>;
  council_gte?: InputMaybe<Scalars['String']['input']>;
  council_ilike?: InputMaybe<Scalars['String']['input']>;
  council_in?: InputMaybe<Array<Scalars['String']['input']>>;
  council_like?: InputMaybe<Scalars['String']['input']>;
  council_lt?: InputMaybe<Scalars['String']['input']>;
  council_lte?: InputMaybe<Scalars['String']['input']>;
  council_ne?: InputMaybe<Scalars['String']['input']>;
  council_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  council_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  council_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreeTagCouncilsOrderByInput = {
  council?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for FreeTagCouncils. */
export type FreeTagCouncilsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FreeTagCouncilsOrderByInput>;
};

export type GenerateBatchCodesInput = {
  isTrial: Scalars['Boolean']['input'];
  materialType: MaterialType;
  numberOfUniqueCodes: Scalars['Float']['input'];
  productType: AssetType;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export enum MaterialType {
  BlendedFibre = 'BLENDED_FIBRE',
  Cardboard = 'CARDBOARD',
  CoffeePods = 'COFFEE_PODS',
  LiquidPaperBoard = 'LIQUID_PAPER_BOARD',
  MixedPaper = 'MIXED_PAPER',
  MixedPlastic = 'MIXED_PLASTIC',
  SoftPlastic = 'SOFT_PLASTIC',
  Textiles = 'TEXTILES'
}

/** This is an object of key-value pairs. By convention we expect the following keys, which users can enter in Stripe in the metadata field. They will need to type the exact key and the value. Keep in mind that all values are strings. */
export type Metadata = {
  __typename?: 'Metadata';
  background_colour?: Maybe<Scalars['String']['output']>;
  entries_gained_per_scan?: Maybe<Scalars['String']['output']>;
  free_shipping?: Maybe<Scalars['String']['output']>;
  free_tag_limit?: Maybe<Scalars['String']['output']>;
  information_section_item_1?: Maybe<Scalars['String']['output']>;
  information_section_item_2?: Maybe<Scalars['String']['output']>;
  information_section_list?: Maybe<Scalars['String']['output']>;
  is_subscription?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update MultipleMetadata. If an ID is passed, this is an update, otherwise it's an insert. */
export type MetadataCreateOrUpdateInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create MultipleMetadata. */
export type MetadataInsertInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update MultipleMetadata. An ID must be passed. */
export type MetadataUpdateInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

/** This is an object of key-value pairs. By convention we expect the following keys, which users can enter in Stripe in the metadata field. They will need to type the exact key and the value. Keep in mind that all values are strings. */
export type MultipleMetadataListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleMetadataListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<MultipleMetadataListFilter>>>;
  background_colour?: InputMaybe<Scalars['String']['input']>;
  background_colour_gt?: InputMaybe<Scalars['String']['input']>;
  background_colour_gte?: InputMaybe<Scalars['String']['input']>;
  background_colour_ilike?: InputMaybe<Scalars['String']['input']>;
  background_colour_in?: InputMaybe<Array<Scalars['String']['input']>>;
  background_colour_like?: InputMaybe<Scalars['String']['input']>;
  background_colour_lt?: InputMaybe<Scalars['String']['input']>;
  background_colour_lte?: InputMaybe<Scalars['String']['input']>;
  background_colour_ne?: InputMaybe<Scalars['String']['input']>;
  background_colour_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  background_colour_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  background_colour_null?: InputMaybe<Scalars['Boolean']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_gt?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_gte?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_ilike?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  entries_gained_per_scan_like?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_lt?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_lte?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_ne?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  entries_gained_per_scan_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entries_gained_per_scan_null?: InputMaybe<Scalars['Boolean']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_shipping_gt?: InputMaybe<Scalars['String']['input']>;
  free_shipping_gte?: InputMaybe<Scalars['String']['input']>;
  free_shipping_ilike?: InputMaybe<Scalars['String']['input']>;
  free_shipping_in?: InputMaybe<Array<Scalars['String']['input']>>;
  free_shipping_like?: InputMaybe<Scalars['String']['input']>;
  free_shipping_lt?: InputMaybe<Scalars['String']['input']>;
  free_shipping_lte?: InputMaybe<Scalars['String']['input']>;
  free_shipping_ne?: InputMaybe<Scalars['String']['input']>;
  free_shipping_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  free_shipping_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  free_shipping_null?: InputMaybe<Scalars['Boolean']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_gt?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_gte?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_ilike?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_in?: InputMaybe<Array<Scalars['String']['input']>>;
  free_tag_limit_like?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_lt?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_lte?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_ne?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  free_tag_limit_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  free_tag_limit_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_1_like?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_1_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_1_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_2_like?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_2_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_2_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  information_section_list_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_list_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_list_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_list_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_list_like?: InputMaybe<Scalars['String']['input']>;
  information_section_list_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_list_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_list_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_list_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_list_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_list_null?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  is_subscription_gt?: InputMaybe<Scalars['String']['input']>;
  is_subscription_gte?: InputMaybe<Scalars['String']['input']>;
  is_subscription_ilike?: InputMaybe<Scalars['String']['input']>;
  is_subscription_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_subscription_like?: InputMaybe<Scalars['String']['input']>;
  is_subscription_lt?: InputMaybe<Scalars['String']['input']>;
  is_subscription_lte?: InputMaybe<Scalars['String']['input']>;
  is_subscription_ne?: InputMaybe<Scalars['String']['input']>;
  is_subscription_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  is_subscription_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription_null?: InputMaybe<Scalars['Boolean']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  order_number_gt?: InputMaybe<Scalars['String']['input']>;
  order_number_gte?: InputMaybe<Scalars['String']['input']>;
  order_number_ilike?: InputMaybe<Scalars['String']['input']>;
  order_number_in?: InputMaybe<Array<Scalars['String']['input']>>;
  order_number_like?: InputMaybe<Scalars['String']['input']>;
  order_number_lt?: InputMaybe<Scalars['String']['input']>;
  order_number_lte?: InputMaybe<Scalars['String']['input']>;
  order_number_ne?: InputMaybe<Scalars['String']['input']>;
  order_number_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  order_number_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  order_number_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  challengePassword?: Maybe<Token>;
  changePassword?: Maybe<Token>;
  /** Create a single AccordionItem. */
  createAccordionItem?: Maybe<AccordionItem>;
  /** Create many AccordionItems. */
  createAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Create a single Account. */
  createAccount?: Maybe<Account>;
  /** Create many Accounts. */
  createAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Create a single BatchCode. */
  createBatchCode?: Maybe<BatchCode>;
  /** Create many BatchCodes. */
  createBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Create a single Blacklist. */
  createBlacklist?: Maybe<Blacklist>;
  /** Create many Blacklists. */
  createBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Create a single Case. */
  createCase?: Maybe<Case>;
  /** Create many Cases. */
  createCases?: Maybe<Array<Maybe<Case>>>;
  /** Create a single Contact. */
  createContact?: Maybe<Contact>;
  /** Create many Contacts. */
  createContacts?: Maybe<Array<Maybe<Contact>>>;
  createCredential?: Maybe<Credential>;
  /** Create a single DropOffLocation. */
  createDropOffLocation?: Maybe<DropOffLocation>;
  /** Create many DropOffLocations. */
  createDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Create a single FreeTagCouncil. */
  createFreeTagCouncil?: Maybe<FreeTagCouncil>;
  /** Create many FreeTagCouncils. */
  createFreeTagCouncils?: Maybe<Array<Maybe<FreeTagCouncil>>>;
  /** Create a single NewsFeed. */
  createNewsFeed?: Maybe<NewsFeed>;
  /** Create many NewsFeeds. */
  createNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Create or update many AccordionItems. */
  createOrUpdateAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Create or update many Accounts. */
  createOrUpdateAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Create or update many BatchCodes. */
  createOrUpdateBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Create or update many Blacklists. */
  createOrUpdateBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Create or update many Cases. */
  createOrUpdateCases?: Maybe<Array<Maybe<Case>>>;
  /** Create or update many Contacts. */
  createOrUpdateContacts?: Maybe<Array<Maybe<Contact>>>;
  /** Create or update many DropOffLocations. */
  createOrUpdateDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Create or update many FreeTagCouncils. */
  createOrUpdateFreeTagCouncils?: Maybe<Array<Maybe<FreeTagCouncil>>>;
  /** Create or update many NewsFeeds. */
  createOrUpdateNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Create or update many PastWinners. */
  createOrUpdatePastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Create or update many Roles. */
  createOrUpdateRoles?: Maybe<Array<Maybe<Role>>>;
  /** Create or update many ScanEventWithTags. */
  createOrUpdateScanEventWithTags?: Maybe<Array<Maybe<ScanEventWithTag>>>;
  /** Create or update many ScanEvents. */
  createOrUpdateScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Create or update many Tags. */
  createOrUpdateTags?: Maybe<Array<Maybe<Tag>>>;
  /** Create or update many TrackableAssets. */
  createOrUpdateTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Create or update many UserAlerts. */
  createOrUpdateUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Create or update many UserPrizeEntryCounts. */
  createOrUpdateUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Create or update many UserSubscriptions. */
  createOrUpdateUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Create or update many Users. */
  createOrUpdateUsers?: Maybe<Array<Maybe<User>>>;
  /** Create a single PastWinner. */
  createPastWinner?: Maybe<PastWinner>;
  /** Create many PastWinners. */
  createPastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Create a single Role. */
  createRole?: Maybe<Role>;
  /** Create many Roles. */
  createRoles?: Maybe<Array<Maybe<Role>>>;
  /** Create a Salesforce case. This cannot currently be done by `createCase` base mutation. */
  createSalesforceCase?: Maybe<Case>;
  /** Create a single ScanEvent. */
  createScanEvent?: Maybe<ScanEvent>;
  /** Create a single ScanEventWithTag. */
  createScanEventWithTag?: Maybe<ScanEventWithTag>;
  /** Create many ScanEventWithTags. */
  createScanEventWithTags?: Maybe<Array<Maybe<ScanEventWithTag>>>;
  /** Create many ScanEvents. */
  createScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  createSessionForOneOffPayment?: Maybe<StripeCreateSessionResult>;
  createSessionForSubscriptionPayment?: Maybe<StripeCreateSessionResult>;
  /** Create a single Tag. */
  createTag?: Maybe<Tag>;
  /** Create many Tags. */
  createTags?: Maybe<Array<Maybe<Tag>>>;
  /** Create a single TrackableAsset. */
  createTrackableAsset?: Maybe<TrackableAsset>;
  /** Create many TrackableAssets. */
  createTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Create a single User. */
  createUser?: Maybe<User>;
  /** Create a single UserAlert. */
  createUserAlert?: Maybe<UserAlert>;
  /** Create many UserAlerts. */
  createUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Create a single UserPrizeEntryCount. */
  createUserPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Create many UserPrizeEntryCounts. */
  createUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Create a single UserSubscription. */
  createUserSubscription?: Maybe<UserSubscription>;
  /** Create many UserSubscriptions. */
  createUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Create many Users. */
  createUsers?: Maybe<Array<Maybe<User>>>;
  customCreateUser?: Maybe<Token>;
  /** Delete a single AccordionItem. */
  deleteAccordionItem?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many AccordionItems with a filter. */
  deleteAccordionItems?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Account. */
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Accounts with a filter. */
  deleteAccounts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single BatchCode. */
  deleteBatchCode?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many BatchCodes with a filter. */
  deleteBatchCodes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Blacklist. */
  deleteBlacklist?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Blacklists with a filter. */
  deleteBlacklists?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Case. */
  deleteCase?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Cases with a filter. */
  deleteCases?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Contact. */
  deleteContact?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Contacts with a filter. */
  deleteContacts?: Maybe<Scalars['Boolean']['output']>;
  deleteCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single DropOffLocation. */
  deleteDropOffLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many DropOffLocations with a filter. */
  deleteDropOffLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single FreeTagCouncil. */
  deleteFreeTagCouncil?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many FreeTagCouncils with a filter. */
  deleteFreeTagCouncils?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single NewsFeed. */
  deleteNewsFeed?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many NewsFeeds with a filter. */
  deleteNewsFeeds?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single PastWinner. */
  deletePastWinner?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many PastWinners with a filter. */
  deletePastWinners?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Role. */
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Roles with a filter. */
  deleteRoles?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single ScanEvent. */
  deleteScanEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single ScanEventWithTag. */
  deleteScanEventWithTag?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many ScanEventWithTags with a filter. */
  deleteScanEventWithTags?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many ScanEvents with a filter. */
  deleteScanEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Tag. */
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Tags with a filter. */
  deleteTags?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single TrackableAsset. */
  deleteTrackableAsset?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many TrackableAssets with a filter. */
  deleteTrackableAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single User. */
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserAlert. */
  deleteUserAlert?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserAlerts with a filter. */
  deleteUserAlerts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserPrizeEntryCount. */
  deleteUserPrizeEntryCount?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserPrizeEntryCounts with a filter. */
  deleteUserPrizeEntryCounts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserSubscription. */
  deleteUserSubscription?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserSubscriptions with a filter. */
  deleteUserSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Users with a filter. */
  deleteUsers?: Maybe<Scalars['Boolean']['output']>;
  finaliseSubscription?: Maybe<StripeProduct>;
  generateBatchCodes?: Maybe<BatchCode>;
  loginPassword?: Maybe<Token>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  scanAssetFromUser?: Maybe<ScanEvent>;
  sendResetPasswordLink?: Maybe<Scalars['Boolean']['output']>;
  tagBatchCode?: Maybe<Scalars['Float']['output']>;
  /** Update a single AccordionItem. */
  updateAccordionItem?: Maybe<AccordionItem>;
  /** Update many AccordionItems. */
  updateAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Update a single Account. */
  updateAccount?: Maybe<Account>;
  /** Update many Accounts. */
  updateAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Update a single BatchCode. */
  updateBatchCode?: Maybe<BatchCode>;
  /** Update many BatchCodes. */
  updateBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Update a single Blacklist. */
  updateBlacklist?: Maybe<Blacklist>;
  /** Update many Blacklists. */
  updateBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Update a single Case. */
  updateCase?: Maybe<Case>;
  /** Update many Cases. */
  updateCases?: Maybe<Array<Maybe<Case>>>;
  /** Update a single Contact. */
  updateContact?: Maybe<Contact>;
  /** Update many Contacts. */
  updateContacts?: Maybe<Array<Maybe<Contact>>>;
  updateCredential?: Maybe<Credential>;
  updateCurrentUser?: Maybe<User>;
  /** Update a single DropOffLocation. */
  updateDropOffLocation?: Maybe<DropOffLocation>;
  /** Update many DropOffLocations. */
  updateDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Update a single FreeTagCouncil. */
  updateFreeTagCouncil?: Maybe<FreeTagCouncil>;
  /** Update many FreeTagCouncils. */
  updateFreeTagCouncils?: Maybe<Array<Maybe<FreeTagCouncil>>>;
  /** Update a single NewsFeed. */
  updateNewsFeed?: Maybe<NewsFeed>;
  /** Update many NewsFeeds. */
  updateNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Update a single PastWinner. */
  updatePastWinner?: Maybe<PastWinner>;
  /** Update many PastWinners. */
  updatePastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Update a single Role. */
  updateRole?: Maybe<Role>;
  /** Update many Roles. */
  updateRoles?: Maybe<Array<Maybe<Role>>>;
  /** Update a single ScanEvent. */
  updateScanEvent?: Maybe<ScanEvent>;
  /** Update a single ScanEventWithTag. */
  updateScanEventWithTag?: Maybe<ScanEventWithTag>;
  /** Update many ScanEventWithTags. */
  updateScanEventWithTags?: Maybe<Array<Maybe<ScanEventWithTag>>>;
  /** Update many ScanEvents. */
  updateScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Update a single Tag. */
  updateTag?: Maybe<Tag>;
  /** Update many Tags. */
  updateTags?: Maybe<Array<Maybe<Tag>>>;
  /** Update a single TrackableAsset. */
  updateTrackableAsset?: Maybe<TrackableAsset>;
  /** Update many TrackableAssets. */
  updateTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Update a single User. */
  updateUser?: Maybe<User>;
  /** Update a single UserAlert. */
  updateUserAlert?: Maybe<UserAlert>;
  /** Update many UserAlerts. */
  updateUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Update a single UserPrizeEntryCount. */
  updateUserPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Update many UserPrizeEntryCounts. */
  updateUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Update a single UserSubscription. */
  updateUserSubscription?: Maybe<UserSubscription>;
  /** Update many UserSubscriptions. */
  updateUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Update many Users. */
  updateUsers?: Maybe<Array<Maybe<User>>>;
};


export type MutationChallengePasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangePasswordArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAccordionItemArgs = {
  input: AccordionItemInsertInput;
};


export type MutationCreateAccordionItemsArgs = {
  input: Array<AccordionItemInsertInput>;
};


export type MutationCreateAccountArgs = {
  input: AccountInsertInput;
};


export type MutationCreateAccountsArgs = {
  input: Array<AccountInsertInput>;
};


export type MutationCreateBatchCodeArgs = {
  input: BatchCodeInsertInput;
};


export type MutationCreateBatchCodesArgs = {
  input: Array<BatchCodeInsertInput>;
};


export type MutationCreateBlacklistArgs = {
  input: BlacklistInsertInput;
};


export type MutationCreateBlacklistsArgs = {
  input: Array<BlacklistInsertInput>;
};


export type MutationCreateCaseArgs = {
  input: CaseInsertInput;
};


export type MutationCreateCasesArgs = {
  input: Array<CaseInsertInput>;
};


export type MutationCreateContactArgs = {
  input: ContactInsertInput;
};


export type MutationCreateContactsArgs = {
  input: Array<ContactInsertInput>;
};


export type MutationCreateCredentialArgs = {
  input?: InputMaybe<CredentialInsertInput>;
};


export type MutationCreateDropOffLocationArgs = {
  input: DropOffLocationInsertInput;
};


export type MutationCreateDropOffLocationsArgs = {
  input: Array<DropOffLocationInsertInput>;
};


export type MutationCreateFreeTagCouncilArgs = {
  input: FreeTagCouncilInsertInput;
};


export type MutationCreateFreeTagCouncilsArgs = {
  input: Array<FreeTagCouncilInsertInput>;
};


export type MutationCreateNewsFeedArgs = {
  input: NewsFeedInsertInput;
};


export type MutationCreateNewsFeedsArgs = {
  input: Array<NewsFeedInsertInput>;
};


export type MutationCreateOrUpdateAccordionItemsArgs = {
  input: Array<AccordionItemCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateAccountsArgs = {
  input: Array<AccountCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateBatchCodesArgs = {
  input: Array<BatchCodeCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateBlacklistsArgs = {
  input: Array<BlacklistCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateCasesArgs = {
  input: Array<CaseCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateContactsArgs = {
  input: Array<ContactCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateDropOffLocationsArgs = {
  input: Array<DropOffLocationCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateFreeTagCouncilsArgs = {
  input: Array<FreeTagCouncilCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateNewsFeedsArgs = {
  input: Array<NewsFeedCreateOrUpdateInput>;
};


export type MutationCreateOrUpdatePastWinnersArgs = {
  input: Array<PastWinnerCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateRolesArgs = {
  input: Array<RoleCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateScanEventWithTagsArgs = {
  input: Array<ScanEventWithTagCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateScanEventsArgs = {
  input: Array<ScanEventCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateTagsArgs = {
  input: Array<TagCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateTrackableAssetsArgs = {
  input: Array<TrackableAssetCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserAlertsArgs = {
  input: Array<UserAlertCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUsersArgs = {
  input: Array<UserCreateOrUpdateInput>;
};


export type MutationCreatePastWinnerArgs = {
  input: PastWinnerInsertInput;
};


export type MutationCreatePastWinnersArgs = {
  input: Array<PastWinnerInsertInput>;
};


export type MutationCreateRoleArgs = {
  input: RoleInsertInput;
};


export type MutationCreateRolesArgs = {
  input: Array<RoleInsertInput>;
};


export type MutationCreateSalesforceCaseArgs = {
  input?: InputMaybe<CreateSalesforceCaseInput>;
};


export type MutationCreateScanEventArgs = {
  input: ScanEventInsertInput;
};


export type MutationCreateScanEventWithTagArgs = {
  input: ScanEventWithTagInsertInput;
};


export type MutationCreateScanEventWithTagsArgs = {
  input: Array<ScanEventWithTagInsertInput>;
};


export type MutationCreateScanEventsArgs = {
  input: Array<ScanEventInsertInput>;
};


export type MutationCreateSessionForOneOffPaymentArgs = {
  lineItems?: InputMaybe<Array<InputMaybe<StripeSessionLineItemInput>>>;
};


export type MutationCreateSessionForSubscriptionPaymentArgs = {
  lineItem?: InputMaybe<StripeSessionLineItemInput>;
};


export type MutationCreateTagArgs = {
  input: TagInsertInput;
};


export type MutationCreateTagsArgs = {
  input: Array<TagInsertInput>;
};


export type MutationCreateTrackableAssetArgs = {
  input: TrackableAssetInsertInput;
};


export type MutationCreateTrackableAssetsArgs = {
  input: Array<TrackableAssetInsertInput>;
};


export type MutationCreateUserArgs = {
  input: UserInsertInput;
};


export type MutationCreateUserAlertArgs = {
  input: UserAlertInsertInput;
};


export type MutationCreateUserAlertsArgs = {
  input: Array<UserAlertInsertInput>;
};


export type MutationCreateUserPrizeEntryCountArgs = {
  input: UserPrizeEntryCountInsertInput;
};


export type MutationCreateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountInsertInput>;
};


export type MutationCreateUserSubscriptionArgs = {
  input: UserSubscriptionInsertInput;
};


export type MutationCreateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionInsertInput>;
};


export type MutationCreateUsersArgs = {
  input: Array<UserInsertInput>;
};


export type MutationCustomCreateUserArgs = {
  input?: InputMaybe<CustomCreateUserInput>;
};


export type MutationDeleteAccordionItemArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteAccordionItemsArgs = {
  filter: AccordionItemsListFilter;
};


export type MutationDeleteAccountArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteAccountsArgs = {
  filter: AccountsListFilter;
};


export type MutationDeleteBatchCodeArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteBatchCodesArgs = {
  filter: BatchCodesListFilter;
};


export type MutationDeleteBlacklistArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteBlacklistsArgs = {
  filter: BlacklistsListFilter;
};


export type MutationDeleteCaseArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteCasesArgs = {
  filter: CasesListFilter;
};


export type MutationDeleteContactArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteContactsArgs = {
  filter: ContactsListFilter;
};


export type MutationDeleteCurrentUserArgs = {
  input?: InputMaybe<DeleteCurrentUserInput>;
};


export type MutationDeleteDropOffLocationArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteDropOffLocationsArgs = {
  filter: DropOffLocationsListFilter;
};


export type MutationDeleteFreeTagCouncilArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteFreeTagCouncilsArgs = {
  filter: FreeTagCouncilsListFilter;
};


export type MutationDeleteNewsFeedArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteNewsFeedsArgs = {
  filter: NewsFeedsListFilter;
};


export type MutationDeletePastWinnerArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeletePastWinnersArgs = {
  filter: PastWinnersListFilter;
};


export type MutationDeleteRoleArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteRolesArgs = {
  filter: RolesListFilter;
};


export type MutationDeleteScanEventArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteScanEventWithTagArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteScanEventWithTagsArgs = {
  filter: ScanEventWithTagsListFilter;
};


export type MutationDeleteScanEventsArgs = {
  filter: ScanEventsListFilter;
};


export type MutationDeleteTagArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteTagsArgs = {
  filter: TagsListFilter;
};


export type MutationDeleteTrackableAssetArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteTrackableAssetsArgs = {
  filter: TrackableAssetsListFilter;
};


export type MutationDeleteUserArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserAlertArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserAlertsArgs = {
  filter: UserAlertsListFilter;
};


export type MutationDeleteUserPrizeEntryCountArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserPrizeEntryCountsArgs = {
  filter: UserPrizeEntryCountsListFilter;
};


export type MutationDeleteUserSubscriptionArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserSubscriptionsArgs = {
  filter: UserSubscriptionsListFilter;
};


export type MutationDeleteUsersArgs = {
  filter: UsersListFilter;
};


export type MutationFinaliseSubscriptionArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateBatchCodesArgs = {
  input?: InputMaybe<GenerateBatchCodesInput>;
};


export type MutationLoginPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScanAssetFromUserArgs = {
  input?: InputMaybe<ScanEventFromUserInput>;
};


export type MutationSendResetPasswordLinkArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTagBatchCodeArgs = {
  batchCodeId?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAccordionItemArgs = {
  input: AccordionItemUpdateInput;
};


export type MutationUpdateAccordionItemsArgs = {
  input: Array<AccordionItemUpdateInput>;
};


export type MutationUpdateAccountArgs = {
  input: AccountUpdateInput;
};


export type MutationUpdateAccountsArgs = {
  input: Array<AccountUpdateInput>;
};


export type MutationUpdateBatchCodeArgs = {
  input: BatchCodeUpdateInput;
};


export type MutationUpdateBatchCodesArgs = {
  input: Array<BatchCodeUpdateInput>;
};


export type MutationUpdateBlacklistArgs = {
  input: BlacklistUpdateInput;
};


export type MutationUpdateBlacklistsArgs = {
  input: Array<BlacklistUpdateInput>;
};


export type MutationUpdateCaseArgs = {
  input: CaseUpdateInput;
};


export type MutationUpdateCasesArgs = {
  input: Array<CaseUpdateInput>;
};


export type MutationUpdateContactArgs = {
  input: ContactUpdateInput;
};


export type MutationUpdateContactsArgs = {
  input: Array<ContactUpdateInput>;
};


export type MutationUpdateCredentialArgs = {
  input?: InputMaybe<CredentialUpdateInput>;
};


export type MutationUpdateCurrentUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationUpdateDropOffLocationArgs = {
  input: DropOffLocationUpdateInput;
};


export type MutationUpdateDropOffLocationsArgs = {
  input: Array<DropOffLocationUpdateInput>;
};


export type MutationUpdateFreeTagCouncilArgs = {
  input: FreeTagCouncilUpdateInput;
};


export type MutationUpdateFreeTagCouncilsArgs = {
  input: Array<FreeTagCouncilUpdateInput>;
};


export type MutationUpdateNewsFeedArgs = {
  input: NewsFeedUpdateInput;
};


export type MutationUpdateNewsFeedsArgs = {
  input: Array<NewsFeedUpdateInput>;
};


export type MutationUpdatePastWinnerArgs = {
  input: PastWinnerUpdateInput;
};


export type MutationUpdatePastWinnersArgs = {
  input: Array<PastWinnerUpdateInput>;
};


export type MutationUpdateRoleArgs = {
  input: RoleUpdateInput;
};


export type MutationUpdateRolesArgs = {
  input: Array<RoleUpdateInput>;
};


export type MutationUpdateScanEventArgs = {
  input: ScanEventUpdateInput;
};


export type MutationUpdateScanEventWithTagArgs = {
  input: ScanEventWithTagUpdateInput;
};


export type MutationUpdateScanEventWithTagsArgs = {
  input: Array<ScanEventWithTagUpdateInput>;
};


export type MutationUpdateScanEventsArgs = {
  input: Array<ScanEventUpdateInput>;
};


export type MutationUpdateTagArgs = {
  input: TagUpdateInput;
};


export type MutationUpdateTagsArgs = {
  input: Array<TagUpdateInput>;
};


export type MutationUpdateTrackableAssetArgs = {
  input: TrackableAssetUpdateInput;
};


export type MutationUpdateTrackableAssetsArgs = {
  input: Array<TrackableAssetUpdateInput>;
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


export type MutationUpdateUserAlertArgs = {
  input: UserAlertUpdateInput;
};


export type MutationUpdateUserAlertsArgs = {
  input: Array<UserAlertUpdateInput>;
};


export type MutationUpdateUserPrizeEntryCountArgs = {
  input: UserPrizeEntryCountUpdateInput;
};


export type MutationUpdateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountUpdateInput>;
};


export type MutationUpdateUserSubscriptionArgs = {
  input: UserSubscriptionUpdateInput;
};


export type MutationUpdateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionUpdateInput>;
};


export type MutationUpdateUsersArgs = {
  input: Array<UserUpdateInput>;
};

export type NewsFeed = {
  __typename?: 'NewsFeed';
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Data needed to create or update NewsFeeds. If an ID is passed, this is an update, otherwise it's an insert. */
export type NewsFeedCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create NewsFeeds. */
export type NewsFeedInsertInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Data needed to update NewsFeeds. An ID must be passed. */
export type NewsFeedUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsFeedsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<NewsFeedsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<NewsFeedsListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_gt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_gte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  imageUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl_like?: InputMaybe<Scalars['String']['input']>;
  imageUrl_lt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_lte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ne?: InputMaybe<Scalars['String']['input']>;
  imageUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  linkUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  linkUrl_like?: InputMaybe<Scalars['String']['input']>;
  linkUrl_lt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_lte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_ne?: InputMaybe<Scalars['String']['input']>;
  linkUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  linkUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsFeedsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  imageUrl?: InputMaybe<Sort>;
  linkUrl?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

/** Pagination options for NewsFeeds. */
export type NewsFeedsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NewsFeedsOrderByInput>;
};

export type PasskeyAuthenticationResponse = {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  rawId: Scalars['String']['input'];
  response: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type PasskeyRegistrationResponse = {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  rawId: Scalars['String']['input'];
  response: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type PastWinner = {
  __typename?: 'PastWinner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  prize: Scalars['String']['output'];
};

/** Data needed to create or update PastWinners. If an ID is passed, this is an update, otherwise it's an insert. */
export type PastWinnerCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create PastWinners. */
export type PastWinnerInsertInput = {
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  prize: Scalars['String']['input'];
};

/** Data needed to update PastWinners. An ID must be passed. */
export type PastWinnerUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
};

export type PastWinnersListFilter = {
  _and?: InputMaybe<Array<InputMaybe<PastWinnersListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<PastWinnersListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
  prize_gt?: InputMaybe<Scalars['String']['input']>;
  prize_gte?: InputMaybe<Scalars['String']['input']>;
  prize_ilike?: InputMaybe<Scalars['String']['input']>;
  prize_in?: InputMaybe<Array<Scalars['String']['input']>>;
  prize_like?: InputMaybe<Scalars['String']['input']>;
  prize_lt?: InputMaybe<Scalars['String']['input']>;
  prize_lte?: InputMaybe<Scalars['String']['input']>;
  prize_ne?: InputMaybe<Scalars['String']['input']>;
  prize_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  prize_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  prize_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PastWinnersOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  prize?: InputMaybe<Sort>;
};

/** Pagination options for PastWinners. */
export type PastWinnersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PastWinnersOrderByInput>;
};

export type Query = {
  __typename?: 'Query';
  /** Query used by the Admin UI to introspect the schema and metadata. */
  _graphweaver?: Maybe<AdminUiMetadata>;
  /** Get a single AccordionItem. */
  accordionItem?: Maybe<AccordionItem>;
  /** Get multiple AccordionItems. */
  accordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Get aggregated data for AccordionItems. */
  accordionItems_aggregate?: Maybe<AggregationResult>;
  /** Get a single Account. */
  account?: Maybe<Account>;
  /** Get multiple Accounts. */
  accounts?: Maybe<Array<Maybe<Account>>>;
  /** Get aggregated data for Accounts. */
  accounts_aggregate?: Maybe<AggregationResult>;
  /** Get a single BatchCode. */
  batchCode?: Maybe<BatchCode>;
  /** Get multiple BatchCodes. */
  batchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Get aggregated data for BatchCodes. */
  batchCodes_aggregate?: Maybe<AggregationResult>;
  /** Get a single Blacklist. */
  blacklist?: Maybe<Blacklist>;
  /** Get multiple Blacklists. */
  blacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Get aggregated data for Blacklists. */
  blacklists_aggregate?: Maybe<AggregationResult>;
  /** Get a single Case. */
  case?: Maybe<Case>;
  /** Get multiple Cases. */
  cases?: Maybe<Array<Maybe<Case>>>;
  /** Get aggregated data for Cases. */
  cases_aggregate?: Maybe<AggregationResult>;
  /** Get a single Contact. */
  contact?: Maybe<Contact>;
  /** Get multiple Contacts. */
  contacts?: Maybe<Array<Maybe<Contact>>>;
  /** Get aggregated data for Contacts. */
  contacts_aggregate?: Maybe<AggregationResult>;
  /** Get a single Credential. */
  credential?: Maybe<Credential>;
  /** Get multiple Credentials. */
  credentials?: Maybe<Array<Maybe<Credential>>>;
  /** Get aggregated data for Credentials. */
  credentials_aggregate?: Maybe<AggregationResult>;
  currentUser?: Maybe<User>;
  /** Get a single DropOffLocation. */
  dropOffLocation?: Maybe<DropOffLocation>;
  /** Get multiple DropOffLocations. */
  dropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Get aggregated data for DropOffLocations. */
  dropOffLocations_aggregate?: Maybe<AggregationResult>;
  /** Get a single FreeTagCouncil. */
  freeTagCouncil?: Maybe<FreeTagCouncil>;
  /** Get multiple FreeTagCouncils. */
  freeTagCouncils?: Maybe<Array<Maybe<FreeTagCouncil>>>;
  /** Get aggregated data for FreeTagCouncils. */
  freeTagCouncils_aggregate?: Maybe<AggregationResult>;
  nearestDropOffLocation?: Maybe<DropOffLocation>;
  /** Get a single NewsFeed. */
  newsFeed?: Maybe<NewsFeed>;
  /** Get multiple NewsFeeds. */
  newsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Get aggregated data for NewsFeeds. */
  newsFeeds_aggregate?: Maybe<AggregationResult>;
  /** Get a single PastWinner. */
  pastWinner?: Maybe<PastWinner>;
  /** Get multiple PastWinners. */
  pastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Get aggregated data for PastWinners. */
  pastWinners_aggregate?: Maybe<AggregationResult>;
  /** Get a single Role. */
  role?: Maybe<Role>;
  /** Get multiple Roles. */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Get aggregated data for Roles. */
  roles_aggregate?: Maybe<AggregationResult>;
  /** Get a single ScanEvent. */
  scanEvent?: Maybe<ScanEvent>;
  /** Get a single ScanEventWithTag. */
  scanEventWithTag?: Maybe<ScanEventWithTag>;
  /** Get multiple ScanEventWithTags. */
  scanEventWithTags?: Maybe<Array<Maybe<ScanEventWithTag>>>;
  /** Get aggregated data for ScanEventWithTags. */
  scanEventWithTags_aggregate?: Maybe<AggregationResult>;
  /** Get multiple ScanEvents. */
  scanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Get aggregated data for ScanEvents. */
  scanEvents_aggregate?: Maybe<AggregationResult>;
  stripeOneTimeProducts?: Maybe<Array<Maybe<StripeProduct>>>;
  stripeProduct?: Maybe<StripeProduct>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionProducts?: Maybe<Array<Maybe<StripeProduct>>>;
  /** Get a single Tag. */
  tag?: Maybe<Tag>;
  /** Get multiple Tags. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Get aggregated data for Tags. */
  tags_aggregate?: Maybe<AggregationResult>;
  /** Get a single TrackableAsset. */
  trackableAsset?: Maybe<TrackableAsset>;
  /** Get multiple TrackableAssets. */
  trackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Get aggregated data for TrackableAssets. */
  trackableAssets_aggregate?: Maybe<AggregationResult>;
  /** Get a single User. */
  user?: Maybe<User>;
  /** Get a single UserAlert. */
  userAlert?: Maybe<UserAlert>;
  /** Get multiple UserAlerts. */
  userAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Get aggregated data for UserAlerts. */
  userAlerts_aggregate?: Maybe<AggregationResult>;
  /** Get a single UserPrizeEntryCount. */
  userPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Get multiple UserPrizeEntryCounts. */
  userPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Get aggregated data for UserPrizeEntryCounts. */
  userPrizeEntryCounts_aggregate?: Maybe<AggregationResult>;
  /** Get a single UserSubscription. */
  userSubscription?: Maybe<UserSubscription>;
  /** Gets the currently signed-in user active subscription. */
  userSubscriptionProduct?: Maybe<StripeProduct>;
  /** Get multiple UserSubscriptions. */
  userSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Get aggregated data for UserSubscriptions. */
  userSubscriptions_aggregate?: Maybe<AggregationResult>;
  /** Get multiple Users. */
  users?: Maybe<Array<Maybe<User>>>;
  /** Get aggregated data for Users. */
  users_aggregate?: Maybe<AggregationResult>;
};


export type QueryAccordionItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccordionItemsArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
  pagination?: InputMaybe<AccordionItemsPaginationInput>;
};


export type QueryAccordionItems_AggregateArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountsArgs = {
  filter?: InputMaybe<AccountsListFilter>;
  pagination?: InputMaybe<AccountsPaginationInput>;
};


export type QueryAccounts_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type QueryBatchCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchCodesArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
  pagination?: InputMaybe<BatchCodesPaginationInput>;
};


export type QueryBatchCodes_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type QueryBlacklistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlacklistsArgs = {
  filter?: InputMaybe<BlacklistsListFilter>;
  pagination?: InputMaybe<BlacklistsPaginationInput>;
};


export type QueryBlacklists_AggregateArgs = {
  filter?: InputMaybe<BlacklistsListFilter>;
};


export type QueryCaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCasesArgs = {
  filter?: InputMaybe<CasesListFilter>;
  pagination?: InputMaybe<CasesPaginationInput>;
};


export type QueryCases_AggregateArgs = {
  filter?: InputMaybe<CasesListFilter>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  filter?: InputMaybe<ContactsListFilter>;
  pagination?: InputMaybe<ContactsPaginationInput>;
};


export type QueryContacts_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type QueryCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCredentialsArgs = {
  filter?: InputMaybe<CredentialsListFilter>;
  pagination?: InputMaybe<CredentialsPaginationInput>;
};


export type QueryCredentials_AggregateArgs = {
  filter?: InputMaybe<CredentialsListFilter>;
};


export type QueryDropOffLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDropOffLocationsArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
  pagination?: InputMaybe<DropOffLocationsPaginationInput>;
};


export type QueryDropOffLocations_AggregateArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
};


export type QueryFreeTagCouncilArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFreeTagCouncilsArgs = {
  filter?: InputMaybe<FreeTagCouncilsListFilter>;
  pagination?: InputMaybe<FreeTagCouncilsPaginationInput>;
};


export type QueryFreeTagCouncils_AggregateArgs = {
  filter?: InputMaybe<FreeTagCouncilsListFilter>;
};


export type QueryNearestDropOffLocationArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryNewsFeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsFeedsArgs = {
  filter?: InputMaybe<NewsFeedsListFilter>;
  pagination?: InputMaybe<NewsFeedsPaginationInput>;
};


export type QueryNewsFeeds_AggregateArgs = {
  filter?: InputMaybe<NewsFeedsListFilter>;
};


export type QueryPastWinnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPastWinnersArgs = {
  filter?: InputMaybe<PastWinnersListFilter>;
  pagination?: InputMaybe<PastWinnersPaginationInput>;
};


export type QueryPastWinners_AggregateArgs = {
  filter?: InputMaybe<PastWinnersListFilter>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RolesListFilter>;
  pagination?: InputMaybe<RolesPaginationInput>;
};


export type QueryRoles_AggregateArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type QueryScanEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventWithTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventWithTagsArgs = {
  filter?: InputMaybe<ScanEventWithTagsListFilter>;
  pagination?: InputMaybe<ScanEventWithTagsPaginationInput>;
};


export type QueryScanEventWithTags_AggregateArgs = {
  filter?: InputMaybe<ScanEventWithTagsListFilter>;
};


export type QueryScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
  pagination?: InputMaybe<ScanEventsPaginationInput>;
};


export type QueryScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type QueryStripeProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagsListFilter>;
  pagination?: InputMaybe<TagsPaginationInput>;
};


export type QueryTags_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type QueryTrackableAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
  pagination?: InputMaybe<TrackableAssetsPaginationInput>;
};


export type QueryTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertsArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
  pagination?: InputMaybe<UserAlertsPaginationInput>;
};


export type QueryUserAlerts_AggregateArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type QueryUserPrizeEntryCountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPrizeEntryCountsArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
  pagination?: InputMaybe<UserPrizeEntryCountsPaginationInput>;
};


export type QueryUserPrizeEntryCounts_AggregateArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type QueryUserSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserSubscriptionsArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
  pagination?: InputMaybe<UserSubscriptionsPaginationInput>;
};


export type QueryUserSubscriptions_AggregateArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
  pagination?: InputMaybe<UsersPaginationInput>;
};


export type QueryUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: RoleName;
  users?: Maybe<Array<User>>;
  users_aggregate?: Maybe<AggregationResult>;
};


export type RoleUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type RoleUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update Roles. If an ID is passed, this is an update, otherwise it's an insert. */
export type RoleCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<RoleName>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

/** Data needed to create Roles. */
export type RoleInsertInput = {
  name: RoleName;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export enum RoleName {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

/** Data needed to update Roles. An ID must be passed. */
export type RoleUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<RoleName>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type RolesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<RolesListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<RolesListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<RoleName>;
  name_in?: InputMaybe<Array<RoleName>>;
  name_nin?: InputMaybe<Array<RoleName>>;
  users?: InputMaybe<UsersListFilter>;
};

export type RolesOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for Roles. */
export type RolesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RolesOrderByInput>;
};

export type ScanEvent = {
  __typename?: 'ScanEvent';
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  createdByApplicationType?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  entriesGained: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  material?: Maybe<MaterialType>;
  trackableAsset: TrackableAsset;
  trackableAsset_aggregate?: Maybe<AggregationResult>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['output'];
};


export type ScanEventCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventTrackableAssetArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type ScanEventTrackableAsset_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update ScanEvents. If an ID is passed, this is an update, otherwise it's an insert. */
export type ScanEventCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  material?: InputMaybe<MaterialType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventFromUserInput = {
  createdByUser: Scalars['String']['input'];
  scannableCode: Scalars['String']['input'];
};

/** Data needed to create ScanEvents. */
export type ScanEventInsertInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<MaterialType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['input'];
};

/** Data needed to update ScanEvents. An ID must be passed. */
export type ScanEventUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  material?: InputMaybe<MaterialType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventWithTag = {
  __typename?: 'ScanEventWithTag';
  assetIntendedMaterial?: Maybe<MaterialType>;
  assetSerialNumber?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<AssetType>;
  batchCodeCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  createdByApplicationType?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserAddress?: Maybe<Scalars['String']['output']>;
  createdByUserFirstName?: Maybe<Scalars['String']['output']>;
  createdByUserLastName?: Maybe<Scalars['String']['output']>;
  createdByUserSalesforceId: Scalars['String']['output'];
  createdByUser_aggregate?: Maybe<AggregationResult>;
  entriesGained: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  material?: Maybe<MaterialType>;
  tag?: Maybe<Tag>;
  tag_aggregate?: Maybe<AggregationResult>;
  trackableAsset: TrackableAsset;
  trackableAsset_aggregate?: Maybe<AggregationResult>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['output'];
};


export type ScanEventWithTagCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventWithTagCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventWithTagTagArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type ScanEventWithTagTag_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type ScanEventWithTagTrackableAssetArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type ScanEventWithTagTrackableAsset_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update ScanEventWithTags. If an ID is passed, this is an update, otherwise it's an insert. */
export type ScanEventWithTagCreateOrUpdateInput = {
  assetIntendedMaterial?: InputMaybe<MaterialType>;
  assetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<AssetType>;
  batchCodeCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  createdByUserAddress?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId?: InputMaybe<Scalars['String']['input']>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  material?: InputMaybe<MaterialType>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Data needed to create ScanEventWithTags. */
export type ScanEventWithTagInsertInput = {
  assetIntendedMaterial?: InputMaybe<MaterialType>;
  assetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<AssetType>;
  batchCodeCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  createdByUserAddress?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId: Scalars['String']['input'];
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<MaterialType>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['input'];
};

/** Data needed to update ScanEventWithTags. An ID must be passed. */
export type ScanEventWithTagUpdateInput = {
  assetIntendedMaterial?: InputMaybe<MaterialType>;
  assetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<AssetType>;
  batchCodeCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  createdByUserAddress?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId?: InputMaybe<Scalars['String']['input']>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  material?: InputMaybe<MaterialType>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventWithTagsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ScanEventWithTagsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<ScanEventWithTagsListFilter>>>;
  assetIntendedMaterial?: InputMaybe<MaterialType>;
  assetIntendedMaterial_in?: InputMaybe<Array<MaterialType>>;
  assetIntendedMaterial_nin?: InputMaybe<Array<MaterialType>>;
  assetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_gt?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_gte?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetSerialNumber_like?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_lt?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_lte?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_ne?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  assetSerialNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  assetSerialNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  assetType?: InputMaybe<AssetType>;
  assetType_in?: InputMaybe<Array<AssetType>>;
  assetType_nin?: InputMaybe<Array<AssetType>>;
  batchCodeCode?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_gt?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_gte?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_ilike?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCodeCode_like?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_lt?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_lte?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_ne?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCodeCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  batchCodeCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_like?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ne?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  createdByUserAddress?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserAddress_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserFirstName_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserFirstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserFirstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserLastName?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserLastName_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserLastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserLastName_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserSalesforceId?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserSalesforceId_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserSalesforceId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserSalesforceId_null?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_ne?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  material_in?: InputMaybe<Array<MaterialType>>;
  material_nin?: InputMaybe<Array<MaterialType>>;
  tag?: InputMaybe<TagsListFilter>;
  trackableAsset?: InputMaybe<TrackableAssetsListFilter>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventWithTagsOrderByInput = {
  assetIntendedMaterial?: InputMaybe<Sort>;
  assetSerialNumber?: InputMaybe<Sort>;
  assetType?: InputMaybe<Sort>;
  batchCodeCode?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  createdByApplicationType?: InputMaybe<Sort>;
  createdByUserAddress?: InputMaybe<Sort>;
  createdByUserFirstName?: InputMaybe<Sort>;
  createdByUserLastName?: InputMaybe<Sort>;
  createdByUserSalesforceId?: InputMaybe<Sort>;
  entriesGained?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  material?: InputMaybe<Sort>;
  wasExcludedFromPrizeEntries?: InputMaybe<Sort>;
};

/** Pagination options for ScanEventWithTags. */
export type ScanEventWithTagsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScanEventWithTagsOrderByInput>;
};

export type ScanEventsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ScanEventsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<ScanEventsListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_like?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ne?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_ne?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  material_in?: InputMaybe<Array<MaterialType>>;
  material_nin?: InputMaybe<Array<MaterialType>>;
  trackableAsset?: InputMaybe<TrackableAssetsListFilter>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  createdByApplicationType?: InputMaybe<Sort>;
  entriesGained?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  material?: InputMaybe<Sort>;
  wasExcludedFromPrizeEntries?: InputMaybe<Sort>;
};

/** Pagination options for ScanEvents. */
export type ScanEventsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScanEventsOrderByInput>;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StripeCreateSessionResult = {
  __typename?: 'StripeCreateSessionResult';
  clientSecret: Scalars['String']['output'];
};

/** Data needed to create or update StripeCreateSessionResults. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripeCreateSessionResultCreateOrUpdateInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create StripeCreateSessionResults. */
export type StripeCreateSessionResultInsertInput = {
  clientSecret: Scalars['String']['input'];
};

/** Data needed to update StripeCreateSessionResults. An ID must be passed. */
export type StripeCreateSessionResultUpdateInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCreateSessionResultsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripeCreateSessionResultsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<StripeCreateSessionResultsListFilter>>>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  clientSecret_gt?: InputMaybe<Scalars['String']['input']>;
  clientSecret_gte?: InputMaybe<Scalars['String']['input']>;
  clientSecret_ilike?: InputMaybe<Scalars['String']['input']>;
  clientSecret_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSecret_like?: InputMaybe<Scalars['String']['input']>;
  clientSecret_lt?: InputMaybe<Scalars['String']['input']>;
  clientSecret_lte?: InputMaybe<Scalars['String']['input']>;
  clientSecret_ne?: InputMaybe<Scalars['String']['input']>;
  clientSecret_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSecret_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  clientSecret_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  unit_amount: Scalars['Float']['output'];
};

/** Data needed to create or update StripePrices. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripePriceCreateOrUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
};

/** Data needed to create StripePrices. */
export type StripePriceInsertInput = {
  active: Scalars['Boolean']['input'];
  unit_amount: Scalars['Float']['input'];
};

/** Data needed to update StripePrices. An ID must be passed. */
export type StripePriceUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type StripePricesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripePricesListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<StripePricesListFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_ne?: InputMaybe<Scalars['Boolean']['input']>;
  active_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  active_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_ilike?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_like?: InputMaybe<Scalars['String']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_ne?: InputMaybe<Scalars['String']['input']>;
  id_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  unit_amount_ne?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  unit_amount_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  unit_amount_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active: Scalars['Boolean']['output'];
  default_price?: Maybe<StripePrice>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Metadata>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update StripeProducts. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripeProductCreateOrUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create StripeProducts. */
export type StripeProductInsertInput = {
  active: Scalars['Boolean']['input'];
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update StripeProducts. An ID must be passed. */
export type StripeProductUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StripeProductsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripeProductsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<StripeProductsListFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_ne?: InputMaybe<Scalars['Boolean']['input']>;
  active_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  active_null?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePricesListFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_ilike?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_like?: InputMaybe<Scalars['String']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_ne?: InputMaybe<Scalars['String']['input']>;
  id_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MultipleMetadataListFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeSessionLineItemInput = {
  priceId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  excludeFromPrizeEntries: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  trackableAssets?: Maybe<Array<TrackableAsset>>;
  trackableAssets_aggregate?: Maybe<AggregationResult>;
};


export type TagTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TagTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update Tags. If an ID is passed, this is an update, otherwise it's an insert. */
export type TagCreateOrUpdateInput = {
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to create Tags. */
export type TagInsertInput = {
  excludeFromPrizeEntries: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to update Tags. An ID must be passed. */
export type TagUpdateInput = {
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

export type TagsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<TagsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<TagsListFilter>>>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssets?: InputMaybe<TrackableAssetsListFilter>;
};

export type TagsOrderByInput = {
  excludeFromPrizeEntries?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for Tags. */
export type TagsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TagsOrderByInput>;
};

export type Token = {
  __typename?: 'Token';
  authToken: Scalars['String']['output'];
};

export type TrackableAsset = {
  __typename?: 'TrackableAsset';
  assetType?: Maybe<AssetType>;
  batchCode?: Maybe<BatchCode>;
  batchCode_aggregate?: Maybe<AggregationResult>;
  codeUrl?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  excludeFromPrizeEntries: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intendedMaterial?: Maybe<MaterialType>;
  scanEvents?: Maybe<Array<ScanEvent>>;
  scanEvents_aggregate?: Maybe<AggregationResult>;
  scannableCode?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Tag>;
  tag_aggregate?: Maybe<AggregationResult>;
};


export type TrackableAssetBatchCodeArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type TrackableAssetBatchCode_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type TrackableAssetCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type TrackableAssetCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type TrackableAssetScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type TrackableAssetScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type TrackableAssetTagArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type TrackableAssetTag_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};

/** Data needed to create or update TrackableAssets. If an ID is passed, this is an update, otherwise it's an insert. */
export type TrackableAssetCreateOrUpdateInput = {
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
};

/** Data needed to create TrackableAssets. */
export type TrackableAssetInsertInput = {
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  excludeFromPrizeEntries: Scalars['Boolean']['input'];
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
};

/** Data needed to update TrackableAssets. An ID must be passed. */
export type TrackableAssetUpdateInput = {
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
};

export type TrackableAssetsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<TrackableAssetsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<TrackableAssetsListFilter>>>;
  assetType?: InputMaybe<AssetType>;
  assetType_in?: InputMaybe<Array<AssetType>>;
  assetType_nin?: InputMaybe<Array<AssetType>>;
  batchCode?: InputMaybe<BatchCodesListFilter>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  codeUrl_gt?: InputMaybe<Scalars['String']['input']>;
  codeUrl_gte?: InputMaybe<Scalars['String']['input']>;
  codeUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  codeUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  codeUrl_like?: InputMaybe<Scalars['String']['input']>;
  codeUrl_lt?: InputMaybe<Scalars['String']['input']>;
  codeUrl_lte?: InputMaybe<Scalars['String']['input']>;
  codeUrl_ne?: InputMaybe<Scalars['String']['input']>;
  codeUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  codeUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  codeUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  intendedMaterial?: InputMaybe<MaterialType>;
  intendedMaterial_in?: InputMaybe<Array<MaterialType>>;
  intendedMaterial_nin?: InputMaybe<Array<MaterialType>>;
  scanEvents?: InputMaybe<ScanEventsListFilter>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  scannableCode_gt?: InputMaybe<Scalars['String']['input']>;
  scannableCode_gte?: InputMaybe<Scalars['String']['input']>;
  scannableCode_ilike?: InputMaybe<Scalars['String']['input']>;
  scannableCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scannableCode_like?: InputMaybe<Scalars['String']['input']>;
  scannableCode_lt?: InputMaybe<Scalars['String']['input']>;
  scannableCode_lte?: InputMaybe<Scalars['String']['input']>;
  scannableCode_ne?: InputMaybe<Scalars['String']['input']>;
  scannableCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  scannableCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  scannableCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber_gt?: InputMaybe<Scalars['String']['input']>;
  serialNumber_gte?: InputMaybe<Scalars['String']['input']>;
  serialNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  serialNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumber_like?: InputMaybe<Scalars['String']['input']>;
  serialNumber_lt?: InputMaybe<Scalars['String']['input']>;
  serialNumber_lte?: InputMaybe<Scalars['String']['input']>;
  serialNumber_ne?: InputMaybe<Scalars['String']['input']>;
  serialNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<TagsListFilter>;
};

export type TrackableAssetsOrderByInput = {
  assetType?: InputMaybe<Sort>;
  codeUrl?: InputMaybe<Sort>;
  excludeFromPrizeEntries?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  intendedMaterial?: InputMaybe<Sort>;
  scannableCode?: InputMaybe<Sort>;
  serialNumber?: InputMaybe<Sort>;
};

/** Pagination options for TrackableAssets. */
export type TrackableAssetsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TrackableAssetsOrderByInput>;
};

export type User = {
  __typename?: 'User';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  batchCodes?: Maybe<Array<BatchCode>>;
  batchCodes_aggregate?: Maybe<AggregationResult>;
  binReminderEnabled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  contact_aggregate?: Maybe<AggregationResult>;
  council?: Maybe<Scalars['String']['output']>;
  createdTrackableAssets?: Maybe<Array<TrackableAsset>>;
  createdTrackableAssets_aggregate?: Maybe<AggregationResult>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  dwellingType?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  householdSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isManualAddress?: Maybe<Scalars['Boolean']['output']>;
  isOver18?: Maybe<Scalars['Boolean']['output']>;
  isParticipatingInPrizeDraw?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  migrationAccountUuid?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  pushSubscription?: Maybe<Scalars['JSON']['output']>;
  roles?: Maybe<Array<Role>>;
  roles_aggregate?: Maybe<AggregationResult>;
  salesforceContactId: Scalars['String']['output'];
  scanEvents?: Maybe<Array<ScanEvent>>;
  scanEvents_aggregate?: Maybe<AggregationResult>;
  state?: Maybe<Scalars['String']['output']>;
  userAlerts: Array<UserAlert>;
  userAlerts_aggregate?: Maybe<AggregationResult>;
  userPrizeEntryCounts?: Maybe<Array<UserPrizeEntryCount>>;
  userPrizeEntryCounts_aggregate?: Maybe<AggregationResult>;
  userSubscriptions?: Maybe<Array<UserSubscription>>;
  userSubscriptions_aggregate?: Maybe<AggregationResult>;
};


export type UserBatchCodesArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type UserBatchCodes_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type UserContactArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type UserContact_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type UserCreatedTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type UserCreatedTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type UserRolesArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type UserRoles_AggregateArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type UserScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type UserScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type UserUserAlertsArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type UserUserAlerts_AggregateArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type UserUserPrizeEntryCountsArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type UserUserPrizeEntryCounts_AggregateArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type UserUserSubscriptionsArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};


export type UserUserSubscriptions_AggregateArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};

export type UserAlert = {
  __typename?: 'UserAlert';
  createdAt: Scalars['ISOString']['output'];
  day: UserAlertDay;
  frequency: UserAlertFrequency;
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  time: Scalars['String']['output'];
  updatedAt: Scalars['ISOString']['output'];
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
};


export type UserAlertUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type UserAlertUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserAlerts. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserAlertCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  day?: InputMaybe<UserAlertDay>;
  frequency?: InputMaybe<UserAlertFrequency>;
  from?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export enum UserAlertDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum UserAlertFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** Data needed to create UserAlerts. */
export type UserAlertInsertInput = {
  createdAt: Scalars['ISOString']['input'];
  day: UserAlertDay;
  frequency: UserAlertFrequency;
  from?: InputMaybe<Scalars['Date']['input']>;
  time: Scalars['String']['input'];
  updatedAt: Scalars['ISOString']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to update UserAlerts. An ID must be passed. */
export type UserAlertUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  day?: InputMaybe<UserAlertDay>;
  frequency?: InputMaybe<UserAlertFrequency>;
  from?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export type UserAlertsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserAlertsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<UserAlertsListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  day?: InputMaybe<UserAlertDay>;
  day_in?: InputMaybe<Array<UserAlertDay>>;
  day_nin?: InputMaybe<Array<UserAlertDay>>;
  frequency?: InputMaybe<UserAlertFrequency>;
  frequency_in?: InputMaybe<Array<UserAlertFrequency>>;
  frequency_nin?: InputMaybe<Array<UserAlertFrequency>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  from_gt?: InputMaybe<Scalars['Date']['input']>;
  from_gte?: InputMaybe<Scalars['Date']['input']>;
  from_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  from_lt?: InputMaybe<Scalars['Date']['input']>;
  from_lte?: InputMaybe<Scalars['Date']['input']>;
  from_ne?: InputMaybe<Scalars['Date']['input']>;
  from_nin?: InputMaybe<Array<Scalars['Date']['input']>>;
  from_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  from_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  time_gt?: InputMaybe<Scalars['String']['input']>;
  time_gte?: InputMaybe<Scalars['String']['input']>;
  time_ilike?: InputMaybe<Scalars['String']['input']>;
  time_in?: InputMaybe<Array<Scalars['String']['input']>>;
  time_like?: InputMaybe<Scalars['String']['input']>;
  time_lt?: InputMaybe<Scalars['String']['input']>;
  time_lte?: InputMaybe<Scalars['String']['input']>;
  time_ne?: InputMaybe<Scalars['String']['input']>;
  time_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  time_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  time_null?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  updatedAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
};

export type UserAlertsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  day?: InputMaybe<Sort>;
  frequency?: InputMaybe<Sort>;
  from?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  time?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

/** Pagination options for UserAlerts. */
export type UserAlertsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserAlertsOrderByInput>;
};

/** Data needed to create or update Users. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserCreateOrUpdateInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  council?: InputMaybe<Scalars['String']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UserInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Users. */
export type UserInsertInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  council?: InputMaybe<Scalars['String']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId: Scalars['String']['input'];
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UserPrizeEntryCount = {
  __typename?: 'UserPrizeEntryCount';
  address?: Maybe<Scalars['String']['output']>;
  count: Scalars['Float']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  periodType: Scalars['String']['output'];
  periodValue: Scalars['Float']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
};


export type UserPrizeEntryCountUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type UserPrizeEntryCountUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserPrizeEntryCounts. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserPrizeEntryCountCreateOrUpdateInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to create UserPrizeEntryCounts. */
export type UserPrizeEntryCountInsertInput = {
  count: Scalars['Float']['input'];
  periodType: Scalars['String']['input'];
  periodValue: Scalars['Float']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to update UserPrizeEntryCounts. An ID must be passed. */
export type UserPrizeEntryCountUpdateInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export type UserPrizeEntryCountsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserPrizeEntryCountsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<UserPrizeEntryCountsListFilter>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_ilike?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_like?: InputMaybe<Scalars['String']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_ne?: InputMaybe<Scalars['String']['input']>;
  address_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  address_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  address_null?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  count_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  count_ne?: InputMaybe<Scalars['Float']['input']>;
  count_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  count_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  count_null?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_gt?: InputMaybe<Scalars['String']['input']>;
  firstName_gte?: InputMaybe<Scalars['String']['input']>;
  firstName_ilike?: InputMaybe<Scalars['String']['input']>;
  firstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_like?: InputMaybe<Scalars['String']['input']>;
  firstName_lt?: InputMaybe<Scalars['String']['input']>;
  firstName_lte?: InputMaybe<Scalars['String']['input']>;
  firstName_ne?: InputMaybe<Scalars['String']['input']>;
  firstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_gt?: InputMaybe<Scalars['String']['input']>;
  lastName_gte?: InputMaybe<Scalars['String']['input']>;
  lastName_ilike?: InputMaybe<Scalars['String']['input']>;
  lastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_like?: InputMaybe<Scalars['String']['input']>;
  lastName_lt?: InputMaybe<Scalars['String']['input']>;
  lastName_lte?: InputMaybe<Scalars['String']['input']>;
  lastName_ne?: InputMaybe<Scalars['String']['input']>;
  lastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_null?: InputMaybe<Scalars['Boolean']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodType_gt?: InputMaybe<Scalars['String']['input']>;
  periodType_gte?: InputMaybe<Scalars['String']['input']>;
  periodType_ilike?: InputMaybe<Scalars['String']['input']>;
  periodType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  periodType_like?: InputMaybe<Scalars['String']['input']>;
  periodType_lt?: InputMaybe<Scalars['String']['input']>;
  periodType_lte?: InputMaybe<Scalars['String']['input']>;
  periodType_ne?: InputMaybe<Scalars['String']['input']>;
  periodType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  periodType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  periodType_null?: InputMaybe<Scalars['Boolean']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  periodValue_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  periodValue_ne?: InputMaybe<Scalars['Float']['input']>;
  periodValue_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  periodValue_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  periodValue_null?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_like?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ne?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
};

export type UserPrizeEntryCountsOrderByInput = {
  address?: InputMaybe<Sort>;
  count?: InputMaybe<Sort>;
  firstName?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lastName?: InputMaybe<Sort>;
  periodType?: InputMaybe<Sort>;
  periodValue?: InputMaybe<Sort>;
  phoneNumber?: InputMaybe<Sort>;
};

/** Pagination options for UserPrizeEntryCounts. */
export type UserPrizeEntryCountsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserPrizeEntryCountsOrderByInput>;
};

/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscription = {
  __typename?: 'UserSubscription';
  id: Scalars['ID']['output'];
  stripeProductId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
  validFrom: Scalars['Date']['output'];
  validTo: Scalars['Date']['output'];
};


/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserSubscriptions. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserSubscriptionCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

/** Data needed to create UserSubscriptions. */
export type UserSubscriptionInsertInput = {
  stripeProductId: Scalars['String']['input'];
  stripeSessionId: Scalars['String']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom: Scalars['Date']['input'];
  validTo: Scalars['Date']['input'];
};

/** Data needed to update UserSubscriptions. An ID must be passed. */
export type UserSubscriptionUpdateInput = {
  id: Scalars['ID']['input'];
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserSubscriptionsListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<UserSubscriptionsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_gt?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_gte?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_ilike?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeProductId_like?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_lt?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_lte?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_ne?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeProductId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  stripeProductId_null?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_gt?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_gte?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_ilike?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeSessionId_like?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_lt?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_lte?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_ne?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeSessionId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSessionId_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validFrom_gt?: InputMaybe<Scalars['Date']['input']>;
  validFrom_gte?: InputMaybe<Scalars['Date']['input']>;
  validFrom_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFrom_lt?: InputMaybe<Scalars['Date']['input']>;
  validFrom_lte?: InputMaybe<Scalars['Date']['input']>;
  validFrom_ne?: InputMaybe<Scalars['Date']['input']>;
  validFrom_nin?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFrom_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom_null?: InputMaybe<Scalars['Boolean']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
  validTo_gt?: InputMaybe<Scalars['Date']['input']>;
  validTo_gte?: InputMaybe<Scalars['Date']['input']>;
  validTo_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  validTo_lt?: InputMaybe<Scalars['Date']['input']>;
  validTo_lte?: InputMaybe<Scalars['Date']['input']>;
  validTo_ne?: InputMaybe<Scalars['Date']['input']>;
  validTo_nin?: InputMaybe<Array<Scalars['Date']['input']>>;
  validTo_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  validTo_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionsOrderByInput = {
  id?: InputMaybe<Sort>;
  stripeProductId?: InputMaybe<Sort>;
  stripeSessionId?: InputMaybe<Sort>;
  validFrom?: InputMaybe<Sort>;
  validTo?: InputMaybe<Sort>;
};

/** Pagination options for UserSubscriptions. */
export type UserSubscriptionsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserSubscriptionsOrderByInput>;
};

/** Data needed to update Users. An ID must be passed. */
export type UserUpdateInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  council?: InputMaybe<Scalars['String']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UsersListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UsersListFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<UsersListFilter>>>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine1_gt?: InputMaybe<Scalars['String']['input']>;
  addressLine1_gte?: InputMaybe<Scalars['String']['input']>;
  addressLine1_ilike?: InputMaybe<Scalars['String']['input']>;
  addressLine1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine1_like?: InputMaybe<Scalars['String']['input']>;
  addressLine1_lt?: InputMaybe<Scalars['String']['input']>;
  addressLine1_lte?: InputMaybe<Scalars['String']['input']>;
  addressLine1_ne?: InputMaybe<Scalars['String']['input']>;
  addressLine1_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine1_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine1_null?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine2_gt?: InputMaybe<Scalars['String']['input']>;
  addressLine2_gte?: InputMaybe<Scalars['String']['input']>;
  addressLine2_ilike?: InputMaybe<Scalars['String']['input']>;
  addressLine2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine2_like?: InputMaybe<Scalars['String']['input']>;
  addressLine2_lt?: InputMaybe<Scalars['String']['input']>;
  addressLine2_lte?: InputMaybe<Scalars['String']['input']>;
  addressLine2_ne?: InputMaybe<Scalars['String']['input']>;
  addressLine2_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine2_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine2_null?: InputMaybe<Scalars['Boolean']['input']>;
  batchCodes?: InputMaybe<BatchCodesListFilter>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  binReminderEnabled_ne?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  binReminderEnabled_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_null?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_gt?: InputMaybe<Scalars['String']['input']>;
  city_gte?: InputMaybe<Scalars['String']['input']>;
  city_ilike?: InputMaybe<Scalars['String']['input']>;
  city_in?: InputMaybe<Array<Scalars['String']['input']>>;
  city_like?: InputMaybe<Scalars['String']['input']>;
  city_lt?: InputMaybe<Scalars['String']['input']>;
  city_lte?: InputMaybe<Scalars['String']['input']>;
  city_ne?: InputMaybe<Scalars['String']['input']>;
  city_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  city_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  city_null?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<ContactsListFilter>;
  council?: InputMaybe<Scalars['String']['input']>;
  council_gt?: InputMaybe<Scalars['String']['input']>;
  council_gte?: InputMaybe<Scalars['String']['input']>;
  council_ilike?: InputMaybe<Scalars['String']['input']>;
  council_in?: InputMaybe<Array<Scalars['String']['input']>>;
  council_like?: InputMaybe<Scalars['String']['input']>;
  council_lt?: InputMaybe<Scalars['String']['input']>;
  council_lte?: InputMaybe<Scalars['String']['input']>;
  council_ne?: InputMaybe<Scalars['String']['input']>;
  council_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  council_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  council_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdTrackableAssets?: InputMaybe<TrackableAssetsListFilter>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_gt?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  dateOfBirth_lt?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_lte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_ne?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_nin?: InputMaybe<Array<Scalars['Date']['input']>>;
  dateOfBirth_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth_null?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ilike?: InputMaybe<Scalars['String']['input']>;
  dwellingType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_like?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ne?: InputMaybe<Scalars['String']['input']>;
  dwellingType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType_null?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ilike?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_like?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ne?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_gt?: InputMaybe<Scalars['String']['input']>;
  gender_gte?: InputMaybe<Scalars['String']['input']>;
  gender_ilike?: InputMaybe<Scalars['String']['input']>;
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_like?: InputMaybe<Scalars['String']['input']>;
  gender_lt?: InputMaybe<Scalars['String']['input']>;
  gender_lte?: InputMaybe<Scalars['String']['input']>;
  gender_ne?: InputMaybe<Scalars['String']['input']>;
  gender_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  gender_null?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hasLoggedIn_ne?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hasLoggedIn_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_null?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  householdSize_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_ne?: InputMaybe<Scalars['Float']['input']>;
  householdSize_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isManualAddress_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isManualAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOver18_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOver18_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_null?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_null?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lat_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_ne?: InputMaybe<Scalars['Float']['input']>;
  lat_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lat_null?: InputMaybe<Scalars['Boolean']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lng_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_ne?: InputMaybe<Scalars['Float']['input']>;
  lng_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lng_null?: InputMaybe<Scalars['Boolean']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_gt?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_gte?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_ilike?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_in?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationAccountUuid_like?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_lt?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_lte?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_ne?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationAccountUuid_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  migrationAccountUuid_null?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_like?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ne?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  pushSubscription_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  pushSubscription_ne?: InputMaybe<Scalars['JSON']['input']>;
  pushSubscription_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  pushSubscription_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  pushSubscription_null?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<RolesListFilter>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_gt?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_gte?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_ilike?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceContactId_like?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_lt?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_lte?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_ne?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceContactId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceContactId_null?: InputMaybe<Scalars['Boolean']['input']>;
  scanEvents?: InputMaybe<ScanEventsListFilter>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_gt?: InputMaybe<Scalars['String']['input']>;
  state_gte?: InputMaybe<Scalars['String']['input']>;
  state_ilike?: InputMaybe<Scalars['String']['input']>;
  state_in?: InputMaybe<Array<Scalars['String']['input']>>;
  state_like?: InputMaybe<Scalars['String']['input']>;
  state_lt?: InputMaybe<Scalars['String']['input']>;
  state_lte?: InputMaybe<Scalars['String']['input']>;
  state_ne?: InputMaybe<Scalars['String']['input']>;
  state_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  state_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  state_null?: InputMaybe<Scalars['Boolean']['input']>;
  userAlerts?: InputMaybe<UserAlertsListFilter>;
  userPrizeEntryCounts?: InputMaybe<UserPrizeEntryCountsListFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionsListFilter>;
};

export type UsersOrderByInput = {
  addressLine1?: InputMaybe<Sort>;
  addressLine2?: InputMaybe<Sort>;
  binReminderEnabled?: InputMaybe<Sort>;
  city?: InputMaybe<Sort>;
  council?: InputMaybe<Sort>;
  dateOfBirth?: InputMaybe<Sort>;
  dwellingType?: InputMaybe<Sort>;
  email?: InputMaybe<Sort>;
  formattedAddress?: InputMaybe<Sort>;
  gender?: InputMaybe<Sort>;
  hasLoggedIn?: InputMaybe<Sort>;
  householdSize?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isManualAddress?: InputMaybe<Sort>;
  isOver18?: InputMaybe<Sort>;
  isParticipatingInPrizeDraw?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lng?: InputMaybe<Sort>;
  migrationAccountUuid?: InputMaybe<Sort>;
  phoneNumber?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  pushSubscription?: InputMaybe<Sort>;
  salesforceContactId?: InputMaybe<Sort>;
  state?: InputMaybe<Sort>;
};

/** Pagination options for Users. */
export type UsersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsersOrderByInput>;
};
